const ROLE = {
    ADMIN : "ADMIN",
    GENRAL : "GENRAL"
}

export default ROLE